import { render, staticRenderFns } from "./addOrEditCategory.vue?vue&type=template&id=1a3556b9&"
import script from "./addOrEditCategory.vue?vue&type=script&lang=js&"
export * from "./addOrEditCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports